<script>
import SimpleTable from "common/visual/SimpleTable.vue"
import Ping from "common/visual/spec/Ping.vue"
import darsan from "darsan"

export default {
    
  components: {SimpleTable, Ping},
    
  props:
  {
    list: Object,
    title: String,
  },
  
  data()
  {
    return {
      data: [],
      ready: false,
    }
  },
  
  methods: {
    async sortData(sortBy, asc)
    {
      if (!this.ready) await this.fetchData()
      
      let sorted = this.data
      
      if (this.filterByLastSeen)
      {
        const threshold = moment().subtract(moment.duration(this.selectedTimespan))
        sorted = this.data.filter(el => moment(el.tstamp).isAfter(threshold, "second"));
      }
      
      switch(sortBy)
      {
        case "vlan":
        case "port":
          sorted = sorted.toSorted((a,b) => a[sortBy] - b[sortBy])
        break;
        case "online":
          sorted = sorted.toSorted((a,b) => !!a.duration - !!b.duration)
        break;
        case "duration":
          sorted = sorted.toSorted((a,b) => a.duration - b.duration)
        break;
        case "tstamp":
          sorted = sorted.toSorted((a,b) => moment(a.tstamp).unix() - moment(b.tstamp).unix())
        break;
        default: 
          sorted = sorted.toSorted((a,b) => (a[sortBy]||"").localeCompare(b[sortBy]||""))
      }

      return asc ? sorted : sorted.toReversed()
    },
    
    async fetchData()
    {
      const abonents = {}
      
      for (const abon of this.list)
      {
        abonents[abon.mac] = abon
      }
      
      const macs = Object.keys(abonents).map(k => k.replace(/:/g,"")).join(",")

      if (macs)
      {
        const clients = await darsan.post("", "client", "/clients-from-macs", {macs})
        for (const el of clients)
        {
          Object.assign(abonents[el.mac], el)
        }
      }
      
      this.data = Object.values(abonents)
    },
  
    pingAll()
    {
      Object.keys(this.$refs).filter(k => k.substring(0,3) == "ip-").forEach(k => this.$refs[k].ping())
    },

    align(column)
    {
      return ["port", "vlan", "ping"].includes(column.name) ? "r" : ""
    },
    
    showLevels(onu)
    {
      const l = []

      if (onu.olt_rx) l.push(`OLT Rx ${onu.olt_rx} dBm`)
      if (onu.onu_rx) l.push(`ONU Rx ${onu.onu_rx} dBm`)
      if (onu.onu_tx) l.push(`ONU Tx ${onu.onu_tx} dBm`)
      if (onu.temperature) l.push(`Темп. ${onu.temperature}&deg;`)
      
      return `<div class="onu-port-level-${onu.level}" title="${onu.problems.join("\n")}"><tt>${l.join("<br/>")}</tt></div>`
    },

  },
  
  watch: {
    async list()
    {
      await this.fetchData()
      this.$refs.table.reloadTable()
    },

    async selectedTimespan()
    {
      this.$refs.table.reloadTable()
    }
  },
}
</script>
